module.exports = __webpack_public_path__ + "img/guide.f57d65f1.gif";